import { TeamTabs } from "@router/route-params";
import { useAppParams } from "@router/router-helper";
import { InviteMemberToTeam } from "@pages/members/teams/invite-member-to-team";
import { TeamCategoryChipIcon } from "@components/table/teams/team-category-chip-icon";
import { SdbTeam } from "@custom-types/teams-types";
import { Stack } from "@mui/material";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";

interface Props {
  /** The team selected */
  selectedTeam: SdbTeam;
}

/**
 * The `isManaged` attribute determines if the team can be removed.
 * So far, I've only seen this enabled for the "All Members" team.
 * For this reason, I'm removing the "Invite Members" button based on this attribute.
 */
export function TeamDetailsInfoBarAction({
  selectedTeam,
}: Props): JSX.Element | null {
  const { teamTabs } = useAppParams();
  const isMembersTab = teamTabs === TeamTabs.members;
  const canInvite = selectedTeam.memberCount && !selectedTeam.category.isManaged;

  if (teamDisplayProperties[selectedTeam.category.kind].isAutoManaged) {
    return (
      <Stack alignItems={"end"}>
        <TeamCategoryChipIcon
          kind={selectedTeam.category.kind}
          shouldShowText={true}
        />
      </Stack>
    );
  }

  if (isMembersTab && canInvite) {
    return <InviteMemberToTeam team={selectedTeam} />;
  }

  return null;
}
